export default {
  raised: 1,
  header: 1,
  elevated: 1,
  modal: 10,
};
